import React, { Component } from "react";
import PatientDetails from "../EmployeeVisitContainer/EmployeeVisitDetailView/PatientDetails";
import VisitDetails from "../EmployeeVisitContainer/EmployeeVisitDetailView/VisitDetails";
// import RightContent from './RightContent';
import WithRouter from "../../hoc/WithRouter";
import WithRoutify from "../../hoc/WithRoutify";
import VisitsService from "../../services/VisitsService";
import EmployeeService from "../../services/EmployeeService";
import CompanyDetails from "../EmployeeVisitContainer/EmployeeVisitDetailView/CompanyDetails";
import { connect } from "react-redux";
import LookupService from "../../services/LookupService";
import InjuryIllnessDetails from "./InjuryIllnessDetails";

import RightContent from "./RightContent";
import BodyComponent from "../../components/UI/BodyComponent";
import OrganComponent from "../../components/UI/OrganComponent";
import HumanSystem from "./HumanSystem";
import AddIncidentModal from "../EmployeeVisitContainer/AddIncidentModal";
import Buttons from "../../components/UI/Buttons";
import IncidentService from "../../services/IncidentService";

class EmrVistDetailView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visitDetails: {},
      employeeId: null,
      employeeDetails: {},
      lookupsOptions: {},
      visitDetails: {},
      selectedBodyPart: [],
      isrenderICD:false,
      showIncident:false,
    };
  }
  async componentDidMount() {
    // Code to run after the component has mounted
    this.fetchVisitList();
    this.getIncidentById();
    // this.fetchLookups();
    // this.toggleSidebar();
  }
  toggleSidebar = () => {
    // document.body.classList.toggle("sidebar-toggled");
    // document.querySelector(".sidebar").classList.toggle("toggled");
    // if (document.querySelector(".sidebar").classList.contains("toggled")) {
    //   document
    //     .querySelectorAll(".sidebar .collapse")
    //     .forEach((el) => el.classList.remove("show"));
    // }
    const body = document.body;
    body.classList.add("sidebar-toggled");
  };
  componentDidUpdate(prevProps, prevState) {
    // Code to run after the component has updated
    if (prevState.employeeId != this.state.employeeId) {
      this.fetchEmployeeDetails(this.state.employeeId);
    }
  }
  // fetchLookups = async () => {
  //   const [chartResult, shippingService] = await Promise.all([
  //     LookupService.getLookupByKey("chart_result"),
  //     LookupService.getLookupByKey("shipping_service"),
  //   ]);
  //   let shippingServiceOptions = [{ label: "-None-", value: "" }];
  //   shippingService.forEach((item) => {
  //     shippingServiceOptions.push({
  //       label: item.value,
  //       value: item.value,
  //     });
  //   });
  //   let chartResultOptions = [{ label: "-None-", value: "" }];
  //   chartResult.forEach((item) => {
  //     chartResultOptions.push({
  //       label: item.value,
  //       value: item.value,
  //     });
  //   });
  //   this.setState({
  //     lookupsOptions: {
  //       shippingService: shippingServiceOptions,
  //       chartResult: chartResultOptions,
  //     },
  //   });
  //   //   console.log('shippingService',shippingService,chartResult);
  // };
  componentWillUnmount() {
   // const body = document.body;
   //body.classList.remove("sidebar-toggled");
  }
  handleEvent = (val, selected) => {
    this.setState((prevState) => {
  let updatedParts = [...prevState.selectedBodyPart];

  if (selected) {
    if (!updatedParts.includes(val)) {
      updatedParts.push(val);
    }
  } else {
    updatedParts = updatedParts.filter((part) => part !== val);
  }

  console.log("render1");

  return {
    selectedBodyPart: updatedParts,
    isrenderICD: updatedParts
  };
});

  };
  incidentToogleHanlder=()=>{
    this.setState({showIncident:!this.state.showIncident})
  }

  render() {
    const visit_id = this.props.params.visitId;
    const { employeeId,showIncident, visitDetails, employeeDetails ,selectedBodyPart} = this.state;
    const { location, navigate, Toast, Loader } = this.props;
    const fromPage = location.state?.from;
    const visit_category = visitDetails["0"]?.visit_category;
  
    console.log("visit_category",visit_category);
    
    return (
      <>
      {(showIncident && (visit_category==="Work Comp - New Injury" || 
        visit_category==="Urgent Care - Injury" || visit_category==="Urgent Care - Illness" || visit_category==="Urgent Care - Follow Up" || visit_category==="Urgent Care - Cash Patient" || visit_category==="Urgent Care - Telehealth" ||
        visit_category==="Private - Mental Health Exam" || visit_category==="Private - Primary Care - Initial" || visit_category==="Private - Primary Care - Follow Up")) &&
     <AddIncidentModal incidentToogleHandler = {this.incidentToogleHanlder} isOpen={showIncident} visitId={visit_id} employeeDetails={employeeDetails} isEdit={true} selectedBodyPart={selectedBodyPart} setSelectedBodyPart={(val) => {
      console.log("✅ setSelectedBodyPart called with value:", val);
      this.setState({ selectedBodyPart: val, isrenderICD: val });
    }} visitCategory={visit_category} />
      }
        <div className="row">
          <div className="col-6 col-lg-3 pt-2">
            <PatientDetails
              visit_id={visit_id}
              employeeId={employeeId}
              employeeDetails={employeeDetails}
              fetchEmployeeDetails={this.fetchEmployeeDetails}
            />
{/* 
            {this.state.selectedBodyPart.length > 0 && (
              <div className="mt-3">
                <h6>🧍 Selected Body Parts:</h6>
                <div className="d-flex flex-wrap gap-3">
                  {this.state.selectedBodyPart.map((part) => (
                    <span
                      key={part}
                      className="badge bg-primary text-capitalize text-white"
                    >
                      {part.replaceAll("_", " ")}
                    </span>
                  ))}
                </div>
              </div>
            )} */}

              {/* {visitDetails?.visit_category ? (
                visitDetails.visit_category === "Urgent Care - Illness" ? (
                  <OrganComponent
                    onClick={this.handleEvent}
                    editValue={selectedBodyPart}
                    type="view"
                  />
                ) : (
                  <div className="d-flex justify-content-center">
                    <BodyComponent
                      type="view"
                      width="50%"
                      onClick={this.handleEvent}
                      editValue={selectedBodyPart}
                    />
                    <BodyComponent
                      view="back"
                      type="view"
                      width="50%"
                      onClick={this.handleEvent}
                      editValue={selectedBodyPart}
                    />
                  </div>
                )
              ) : (
                <div>Loading...</div> // or null/spinner
              )} */}
           {(visit_category==="Work Comp - New Injury" || 
             visit_category==="Urgent Care - Injury" || visit_category==="Urgent Care - Illness" || visit_category==="Urgent Care - Follow Up" || visit_category==="Urgent Care - Cash Patient" || visit_category==="Urgent Care - Telehealth" ||
             visit_category==="Private - Mental Health Exam" || visit_category==="Private - Primary Care - Initial" || visit_category==="Private - Primary Care - Follow Up") && 
            <div className="d-flex justify-content-end">
              <Buttons
                className="text-xs text-info"
                label={"Add incident"}
                acl={'any'}
                clickHandler={this.incidentToogleHanlder}
              />
            </div>}
 
         <HumanSystem 
            visit_category={visit_category}
            selectedBodyPart={selectedBodyPart}
            handleEvent={this.handleEvent}
            // organList={this.getOrganList()}
            setSelectedBodyPart={(val) =>
              this.setState({ selectedBodyPart: val, isrenderICD: val }) 
            }
          />

            {/* <VisitDetails
              visit_id={visit_id}
              employeeId={employeeId}
              visitDetails={visitDetails}
              fetchVisitList={this.fetchVisitList}
            />
          </div> */}
          </div>
          {/* <RightContent
              visitDetails={visitDetails}
              visit_id={visit_id}
              employeeDetails={employeeDetails}
              companyDetails={visitDetails.company}
              stateList={this.props.stateList}
              lookupsOptions={this.state.lookupsOptions}
              fetchVisitDetails={this.fetchVisitList}
              fromPage ={fromPage}
            /> */}

          <RightContent
            Loader={Loader}
            visit_id={visit_id}
            employeeId={employeeId}
            Toast={Toast}
            visitDetails={visitDetails}
            selectedBodyPart={this.state.selectedBodyPart}
            isrenderICD={this.state.isrenderICD}
            setSelecetedBodyParts={(selected)=>this.setState({selectedBodyPart:selected})}
          />
        </div>
      </>
    );
  }
  getIncidentById=async()=>{
    try{
      console.log('fetching incident details for visit id:',this.props.params.visitId);
       const response = await IncidentService.getIncidentById(this.props.params.visitId);
       if (response.injury_locations && response.injury_locations.trim() !== "") {
        this.setState((prevState) => ({
          selectedBodyPart: [
            ...prevState.selectedBodyPart,
            response.injury_locations.trim(),
          ],
        }));
      }
       console.log("bodypartt",this.state.selectedBodyPart);
    }catch(err){
      console.error('Error fetching incident details:', err);
    }finally{
      
    }
  }
  fetchVisitList = async (visitId = this.props.params.visitId) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const data = await VisitsService.getVisits(visitId);
      this.setState({
        visitDetails: { ...data[0], ...data },
        employeeId: data[0].employee_id,
      });
      
      // Deleted activities are handled silently - no toast notification
      
      Loader(false);
    } catch (error) {
      Loader(false);
      console.error("Error fetching employee details:", error);
    }
  };
  fetchEmployeeDetails = async (employeeId) => {
    const { Loader } = this.props;
    try {
      if (employeeId) {
        Loader(true);
        const data = await EmployeeService.getEmployee(employeeId);
        this.setState({ employeeDetails: data });
        Loader(false);
      }
    } catch (error) {
      Loader(false);
      console.error("Error fetching employee details:", error);
    }
  };
}

const mapStateToProps = (state) => {
  return {
    stateList: state.session.profileStateList,
  };
};

// Connect the component to Redux store
export default connect(mapStateToProps)(
  WithRouter(WithRoutify(EmrVistDetailView))
);

//  export default WithRouter(WithRoutify(EmrVistDetailView));
